import axios from 'axios'

function getCurrentUser() {
  return axios.get('/api/session.json')
    .then(res => res.data)
}

function signIn(email, password) {
  return axios.post('/api/users/sign_in', { api_user: { email, password } })
    .then(res => res.data)
    .catch(err => err)
}

function signUp(email, password, password_confirmation) {
  return axios.post('/api/users', { api_user: { email, password, password_confirmation } })
    .then(res => res.data)
    .catch(err => err)
}

function signOut() {
  return axios.delete('/api/users/sign_out')
    .then(res => res.data)
}

export default {
  signIn,
  signUp,
  signOut,
  getCurrentUser,
}
